import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import ManagerWrapper from './ManagerWrapper';
import { parseBoolean } from '../../../../Utils/form.util';
import { ManagerContextProvider } from '../../Services/ManagerContext';

loadDOMComponent({
	selector: 'react-manager-wrapper',
	callback: ({ container, context, props }: any) => {
		const isSuperAdmin = parseBoolean(container.getAttribute('isSuperAdmin'));
		const workplaceId = container.getAttribute('workplaceId');
		const activeTab = container.getAttribute('activeTab');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<ManagerContextProvider
							isSuperAdmin={isSuperAdmin}
							workplaceId={workplaceId}>
							<ManagerWrapper activeTab={activeTab} />
						</ManagerContextProvider>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
